import * as flsFunctions from "./files/functions.js";
import "./files/script.js";
// import "./files/forms/range.js";
/*
Модуль работы со спойлерами
Документация:
Сниппет (HTML): spollers
*/
window.addEventListener("load", () => {
    flsFunctions.spollers();
});

/*
Модуль работы с табами
Документация:
Сниппет (HTML): tabs
*/
// flsFunctions.tabs();

/*
Модуль "показать еще"
Документация по работе в шаблоне:
Сниппет (HTML): showmore
*/
// flsFunctions.showMore();

/*
Попапы
Документация по работе в шаблоне:
Сниппет (HTML): pl
*/
import "./libs/popup.js";

/*
Модуль параллакса мышью
Документация по работе в шаблоне:
Сниппет (HTML): 
*/
// import './libs/parallax-mouse.js'

// ========================================================================================================================================================================================================================================================
// Работа с формами ========================================================================================================================================================================================================================================================
// ========================================================================================================================================================================================================================================================
//import * as flsForms from "./files/forms/forms.js";

/* Работа с полями формы */
/* Документация: https://template.fls.guru/template-docs/rabota-s-formami.html */
//flsForms.formFieldsInit({ viewPass: false });

import "./files/sliders.js";
import "./libs/watcher.js";

// Функции работы скроллом
import * as flsScroll from "./files/scroll/scroll.js";

// Плавная навигация по странице
// flsScroll.pageNavigation();

// Функционал добавления классов к хедеру при прокрутке
// flsScroll.headerScroll();

// Функционал липкого блока
// flsScroll.stickyBlock();
import "./libs/sticky-sidebar.js";
window.addEventListener("load", () => {
    if (document.querySelector(".product")) {
        var sidebar = new StickySidebar("[data-sticky]", {
            containerSelector: ".product",
            innerWrapperSelector: ".product-content__inner",
            scrollContainer: "true",
            topSpacing: 80,
            minWidth: 991.98,
        });
    }
});
import "./files/gallery.js";

//import "./files/script.js";
